// extracted by mini-css-extract-plugin
module.exports = {"sidebar-filters":"SidebarFilters_sidebar-filters__43heP"};